import { render, staticRenderFns } from "./pageSelection.vue?vue&type=template&id=2615d7f3&scoped=true&"
import script from "./pageSelection.vue?vue&type=script&lang=js&"
export * from "./pageSelection.vue?vue&type=script&lang=js&"
import style0 from "./pageSelection.vue?vue&type=style&index=0&id=2615d7f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2615d7f3",
  null
  
)

export default component.exports